/**
 * Фирменные цвета внешних сервисов.
 *
 * Единственная категория цветов, которой токены темы противопоказаны: фиолетовый
 * Twitch остаётся фиолетовым Twitch в любой теме, иначе кнопка перестаёт
 * читаться как кнопка Twitch. Гайдлайны брендов прямо это требуют.
 *
 * Модуль нужен, чтобы такие значения были перечислены в одном месте и не
 * выглядели забытым хардкодом при следующей ревизии (KAN-1002): «этот #9146FF
 * осознанный» — утверждение, которое должно быть записано, а не угадано.
 */

export const BRAND_COLORS = {
  twitch: "#9146FF",
  discord: "#5865F2",
  /** X (бывший Twitter): чёрный — часть айдентики, а не цвет темы. */
  x: "#000000",
  /** Ховер для чёрной кнопки X: чуть светлее, чтобы нажатие было заметно. */
  xHover: "#1a1a1a",
} as const;

